import React from 'react';
import { Link } from 'react-router-dom';

// [미도달] 구 예약상세(CustomerDetail) 방문완료 "차량구매 여부" 목록. 방문완료가 워크인 /detail/visited 로 리다이렉트되어 현재 노출되지 않는다.
// 워크인 구매 안 함 사유는 아래 NOT_PURCHASE_REASON_OPTIONS 를 쓴다.
export const PURCHASE_OPTIONS = [
	{
		id: 'purchase_car',
		desc: '차량을 구매할게요',
	},
	{
		id: 'expensive_car',
		desc: '가격이 비싸요',
	},
	{
		id: 'bad_state_car',
		desc: '차량상태가 좋지 않아요',
	},
	{
		id: 'another_car',
		desc: '다른 차량을 더 보고 싶어요',
	},
	{
		id: 'need_loan',
		desc: '대출이 필요해요',
	},
	{
		id: 'just_eyeshoping',
		desc: '단순히 구경하러 왔어요',
	},
];

export const NOT_PURCHASE_REASON_OPTIONS = [
	{
		id: 'CANCEL_VEHICLE_STATUS',
		desc: '차량 상태가 좋지 않아요',
	},
	{
		id: 'CANCEL_BUY_ANOTHER_VEHICLE',
		desc: '다른 차량을 구매할래요',
	},
	{
		id: 'CANCEL_PRICE',
		desc: '가격이 너무 비싸요',
	},
	{
		id: 'CANCEL_CHANGED_MIND',
		desc: '단순히 구경 왔어요',
	},
	{
		id: 'CANCEL_ETC',
		desc: '기타',
	},
];

export const RESERVATION_CANCEL_REASON_OPTIONS = [
	{
		id: 'CANCELLATION_REQUEST_CHANGE',
		desc: '방문예약 일시를 변경하고 싶어요',
	},
	{
		id: 'CANCELLATION_BUY_ANOTHER_VEHICLE',
		desc: '다른 차량을 예약하고 싶어요',
	},
	{
		id: 'CANCELLATION_CENTER_DISTANCE',
		desc: '엔카 센터에 방문하기에 거리가 너무 멀어요',
	},
	{
		id: 'CANCELLATION_USING_ANOTHER_COMPANY',
		desc: '다른 사이트에서 차량을 구매 예정이에요',
	},
	{
		id: 'CANCELLATION_ETC',
		desc: '기타',
	},
];

export const ADJUST_OPTIONS = [
	{
		id: 'APPROVE',
		desc: '고객이 요청한 금액에 판매할게요',
	},
	{
		id: 'COUNTER_OFFER',
		desc: '요청한 금액 중 일부조정 후 판매할게요',
	},
	{
		id: 'REJECT',
		desc: '할인 판매는 불가능해요',
	},
];

export const RESERVATION_TIT = {
	RESERVATION_REQUEST: {
		// 예약신청
		id: 'RESERVATION_REQUEST',
		title: '예약신청 접수',
		discription: '방문예약 신청이\n접수되었습니다.',
		subDiscription: '예약확정 여부는 방문희망일 전날 안내해드려요.',
		carTitle: '신청 차량',
	},
	RESERVATION_CANCEL: {
		// 예약취소
		id: 'RESERVATION_CANCEL',
		title: '예약취소',
		discription: '방문예약이 취소되었어요',
		subDiscription: '',
		carTitle: '취소 차량',
	},
	RESERVATION_CONFIRMED: {
		// 예약확정
		id: 'RESERVATION_CONFIRMED',
		title: '예약확정',
		discription: 'time\n방문 예약이 확정되었습니다.',
		subDiscription: '15분 이상 늦으시면 차량 확인이 어려울 수 있습니다.',
		carTitle: '신청 차량',
	},
	RESERVATION_CONFIRMED_CANCEL: {
		// 예약확정취소
		id: 'RESERVATION_CONFIRMED_CANCEL',
		title: '',
		discription: '',
		subDiscription: '',
		carTitle: '취소 차량',
	},
	VEHICLE_RECEIVING: {
		// 차량입고
		id: 'VEHICLE_RECEIVING',
		title: '',
		discription: '',
		subDiscription: '',
		carTitle: '신청 차량',
	},
	VISIT_CANCEL: {
		// 방문취소
		id: 'VISIT_CANCEL',
		title: '예약취소',
		discription: '방문예약이 취소되었어요',
		subDiscription: '',
		carTitle: '취소 차량',
	},
	VISIT_COMPLETE: {
		// 방문완료
		id: 'VISIT_COMPLETE',
		title: '방문완료',
		discription: '구매여부를 결정하세요',
		subDiscription: '성능 전문가의 성능 설명을 듣고 고민해보세요',
		carTitle: '신청 차량',
	},
	PRICE_ADJUSTMENT: {
		// 가격조정
		id: 'PRICE_ADJUSTMENT',
		title: '',
		discription: '차량 가격 조정을 요청해보세요.',
		subDiscription: '가격 조정 요청 사유를 입력해주세요.',
		carTitle: '신청 차량',
	},
	PRICE_ADJUSTMENT_REQUEST: {
		// 가격조정요청
		id: 'PRICE_ADJUSTMENT_REQUEST',
		title: '',
		discription: '가격 조정중이에요.',
		subDiscription: '잠시만 기다려주세요',
		carTitle: '신청 차량',
	},
	PRICE_ADJUSTMENT_COMPLETE: {
		// 가격조정결과
		id: 'PRICE_ADJUSTMENT_COMPLETE',
		title: '',
		discription: '최종 차량가격을 확인하고 구매하세요',
		subDiscription: '',
		carTitle: '신청 차량',
	},
	CANCEL_PURCHASE: {
		// 구매취소
		id: 'PURCHASE_NOT',
		title: '구매취소',
		discription: '구매 취소되었어요.',
		subDiscription: '',
		carTitle: '취소 차량',
	},
	PURCHASE_NOT: {
		// 구매안함
		id: 'PURCHASE_NOT',
		title: '구매취소',
		discription: '구매 취소되었어요.',
		subDiscription: '',
		carTitle: '취소 차량',
	},
	PURCHASE_PROCEED: {
		// 구매진행
		id: 'PURCHASE_PROCEED',
		title: '계약중',
		discription: '결제를 진행해주세요',
		subDiscription: '자동차 보험 가입이 필요해요',
		carTitle: '신청 차량',
	},
	PURCHASE_CONSULTATION: {
		// 계약중 전자계약서 입금전
		id: 'PURCHASE_CONSULTATION',
		title: '계약중',
		discription: '결제를 진행해주세요',
		subDiscription: '자동차 보험 가입이 필요해요',
		carTitle: '신청 차량',
	},
	PURCHASE_CONSULTATION_BEFORE_CONTRACT: {
		// 계약중 전자계약서 작성전 입금후
		id: 'PURCHASE_CONSULTATION',
		title: '계약중',
		discription: '전자계약서를 작성해주세요',
		subDiscription: '전자계약서 작성 완료 후 차량을 출고할 수 있어요',
		carTitle: '신청 차량',
	},
	COMPLETE_PAYMENT: {
		// 구매완료
		id: 'COMPLETE_PAYMENT',
		title: '구매완료',
		discription: '차량 구매가 완료되었어요',
		subDiscription: '7일이 지나면 자동으로 구매확정됩니다',
		carTitle: '구매 차량',
	},
	COMPLETE_DOWN_PAYMENT: {
		// 계약금 구매완료
		id: 'COMPLETE_DOWN_PAYMENT',
		title: '엔카페이 구매완료',
		discription: '엔카페이 계약금 입금되었어요',
		subDiscription: '7일간 타면서 구매확정해주세요',
		carTitle: '구매 차량',
	},
	UNPAID_BALANCE: {
		// 잔금 미입금 (계약금 구매완료)
		id: 'COMPLETE_DOWN_PAYMENT',
		title: '엔카페이 구매완료',
		discription: '엔카페이 계약금 입금되었어요',
		subDiscription: '7일간 타면서 구매확정해주세요',
		carTitle: '구매 차량',
	},
	CONFIRM_INCOMPLETE: {
		// 미종결 처리 (계약금 구매완료)
		id: 'COMPLETE_DOWN_PAYMENT',
		title: '엔카페이 구매완료',
		discription: '엔카페이 계약금 입금되었어요',
		subDiscription: '7일간 타면서 구매확정해주세요',
		carTitle: '구매 차량',
	},
	COMPLETE_BALANCE: {
		// 엔카페이 잔금 입금 완료
		id: 'COMPLETE_BALANCE',
		title: '엔카페이 구매완료',
		discription: '차량구매가 완료되었어요',
		subDiscription: '7일이 지나면 자동으로 구매확정됩니다.',
		carTitle: '구매 차량',
	},
	CONFIRM_PURCHASE: {
		// 구매확정
		id: 'CONFIRM_PURCHASE',
		title: '구매확정',
		discription: '차량 구매가 확정되었어요',
		subDiscription: '궁금하신 점은 1599-5499로 문의해주세요',
		carTitle: '구매 차량',
	},
	COMPLETE_DOWN_PAYMENT_REFUND: {
		// 환불요청
		id: 'COMPLETE_DOWN_PAYMENT_REFUND',
		title: '',
		discription: '환불요청',
		subDiscription: '담당자가 확인 후 연락드리겠습니다',
		carTitle: '신청 차량',
	},
	REQUEST_REFUND: {
		// 환불요청
		id: 'REQUEST_REFUND',
		title: '환불요청',
		discription: '환불요청을 확인중입니다',
		subDiscription: '담당자가 확인 후 연락드리겠습니다',
		carTitle: '환불요청 차량',
	},
	CONFIRM_REFUND: {
		// 환불완료
		id: 'CONFIRM_REFUND',
		title: '환불완료',
		discription: '환불되었어요',
		subDiscription: '',
		carTitle: '환불완료 차량',
	},
	GIVE_VEHICLE_BACK: {
		// 차량회수요청
		id: 'GIVE_VEHICLE_BACK',
		title: '환불요청',
		discription: '환불요청 진행중입니다.',
		subDiscription: '고객의 환불요청 처리가 완료되면 알려드리겠습니다.',
		carTitle: '환불요청 차량',
	},
};

export const RESERVATION_TIT_SELLER = {
	RESERVATION_REQUEST: {
		id: 'RESERVATION_REQUEST',
		title: '예약확정',
		discription: 'time까지\n차량을 믿고 센터에 입고해주세요',
		subDiscription: '궁금한 점은 믿고 센터로 문의해주세요',
		carTitle: '신청차량',
	},
	RESERVATION_CONFIRMED_NULL: {
		// 예약신청
		id: 'RESERVATION_CONFIRMED_NULL',
		title: '예약확정',
		discription: 'time까지\n차량을 믿고 센터에 입고해주세요',
		subDiscription: '궁금한 점은 믿고 센터로 문의해주세요',
		carTitle: '신청차량',
	},
	RESERVATION_CONFIRMED_RECEIVING_VEHICLE_DEALER_CONFIRM: {
		// 예약확정 딜러확인
		id: 'RESERVATION_CONFIRMED_RECEIVING_VEHICLE_DEALER_CONFIRM',
		title: '입고완료',
		discription: '차량 입고가 완료되었습니다.',
		subDiscription: '진행상황을 안내해드리겠습니다.',
		carTitle: '신청차량',
	},
	RECEIVING_VEHICLE: {
		// 입고확인
		id: 'RECEIVING_VEHICLE',
		title: '입고확인',
		discription: '판매가능 여부를 확인해야\n차량판매가 가능합니다',
		subDiscription: '판매 여부를 한번 더 확인해주세요',
		carTitle: '신청차량',
	},
	RECEIVING_VEHICLE_DEALER_CONFIRM: {
		// 입고완료
		id: 'RECEIVING_VEHICLE_DEALER_CONFIRM',
		title: '입고완료',
		discription: '차량 입고가 완료되었습니다',
		subDiscription: '진행상황을 안내해드리겠습니다.',
		carTitle: '신청차량',
	},
	VISIT_COMPLETE: {
		// 방문완료
		id: 'VISIT_COMPLETE',
		title: '방문완료',
		discription: '고객이 방문하였습니다',
		subDiscription: '진행상황을 안내해드리겠습니다.',
		carTitle: '신청차량',
	},
	PURCHASE_CONSULTATION: {
		// 계약중
		id: 'PURCHASE_CONSULTATION',
		title: '계약중',
		discription: '차량이 계약중입니다',
		subDiscription: '진행상황을 안내해드리겠습니다.',
		carTitle: '신청차량',
	},
	COMPLETE_DOWN_PAYMENT: {
		// 계약금입금완료
		id: 'PURCHASE_CONSULTATION',
		title: '계약중',
		discription: '차량이 계약중입니다',
		subDiscription: '진행상황을 안내해드리겠습니다.',
		carTitle: '신청차량',
	},
	COMPLETE_PAYMENT: {
		// 판매완료
		id: 'COMPLETE_PAYMENT',
		title: '판매완료',
		discription: '차량판매가 완료되었습니다',
		subDiscription: '',
		carTitle: '판매차량',
	},
	COMPLETE_BALANCE: {
		// 엔카페이 판매완료
		id: 'COMPLETE_PAYMENT',
		title: '판매완료',
		discription: '차량판매가 완료되었습니다',
		subDiscription: '',
		carTitle: '판매차량',
	},
	CONFIRM_PURCHASE: {
		// 구매확정
		id: 'CONFIRM_PURCHASE',
		title: '구매확정',
		discription: '고객이 차량구매를\n확정하였습니다',
		subDiscription: '',
		carTitle: '판매차량',
	},
	REQUEST_REFUND: {
		// 환불요청
		id: 'REQUEST_REFUND',
		title: '환불요청',
		discription: '환불요청 진행중입니다.',
		subDiscription: '고객의 환불요청 처리가 완료되면 알려드리겠습니다.',
		carTitle: '환불요청 차량',
	},
	CONFIRM_REFUND: {
		// 환불완료
		id: 'CONFIRM_REFUND',
		title: '환불완료',
		discription: '차량 환불이 완료되었습니다.',
		subDiscription: '새로운 방문예약이 신청되면 다시 알려드리겠습니다.',
		carTitle: '환불완료 차량',
	},
	RESERVATION_CANCEL_NULL: {
		// 예약취소, 입고전
		id: 'RESERVATION_CANCEL_NULL',
		title: '예약취소',
		discription: '방문예약이 취소되었어요',
		subDiscription: '새로운 방문예약이 신청되면 다시 알려드리겠습니다',
		carTitle: '취소 차량',
	},
	RESERVATION_CANCEL_RECEIVING_VEHICLE: {
		// 입고후 예약취소, 수거전
		id: 'RESERVATION_CANCEL_RECEIVING_VEHICLE',
		title: '예약취소',
		discription: 'time까지\n차량을 수거해주세요',
		subDiscription: '',
		carTitle: '취소 차량',
	},
	RECEIVING_VEHICLE_GIVE_VEHICLE_BACK: {
		// 입고후 예약취소, 수거완료
		id: 'RECEIVING_VEHICLE_GIVE_VEHICLE_BACK',
		title: '예약취소',
		discription: '차량 수거가 완료되었습니다',
		subDiscription: '',
		carTitle: '취소 차량',
	},
	CANCEL_PURCHASE_RECEIVING_VEHICLE: {
		// 구매취소, 수거전
		id: 'CANCEL_PURCHASE_RECEIVING_VEHICLE',
		title: '구매취소',
		discription: '입고된 차량을 수거해주세요',
		subDiscription: '고객이 차량 구매를 취소하였어요',
		carTitle: '취소 차량',
	},
	CANCEL_PURCHASE_GIVE_VEHICLE_BACK: {
		// 구매취소, 수거완료
		id: 'CANCEL_PURCHASE_GIVE_VEHICLE_BACK',
		title: '구매취소',
		discription: '차량 수거가 완료되었습니다',
		subDiscription: '',
		carTitle: '취소 차량',
	},
	PRICE_ADJUSTMENT_APPROVE: {
		// 가격 조정 승인
		id: 'PRICE_ADJUSTMENT_APPROVE',
		title: '방문완료',
		discription: '고객이 방문하였습니다',
		subDiscription: '진행상황을 안내해드리겠습니다',
		carTitle: '신청차량',
	},
	PRICE_ADJUSTMENT_COUNTER_OFFER: {
		// 가격 조정 카운터 오퍼
		id: 'PRICE_ADJUSTMENT_COUNTER_OFFER',
		title: '방문완료',
		discription: '고객이 방문하였습니다',
		subDiscription: '진행상황을 안내해드리겠습니다',
		carTitle: '신청차량',
	},
	PRICE_ADJUSTMENT_OFFER: {
		// 가격 조정 진행중
		id: 'PRICE_ADJUSTMENT_OFFER',
		title: '방문완료',
		discription: '고객이 방문하였습니다',
		subDiscription: '진행상황을 안내해드리겠습니다',
		carTitle: '신청차량',
	},
};

export const BOTTOM_SHEET_TITLE = (price) => ({
	OFFER: (
		<>
			방문한 고객이
			<br />
			{price}만원으로 할인 요청합니다
		</>
	),
	APPROVE: (
		<>
			{price}만원으로
			<br />
			판매 승인하였습니다
		</>
	),
	COUNTER_OFFER: (
		<>
			믿고센터에서 판매가격을
			<br />
			확인중입니다
		</>
	),
	COUNTER_OFFER_APPROVE: (
		<>
			믿고센터에서 {price}만원으로
			<br />
			판매 가격을 최종 승인했습니다
		</>
	),
});

export const PROPOSAL_TIT = (price) => ({
	VISIT_COMPLETE: {
		title: '할인된 차량 금액을\n입력해주세요',
		subTitle: <>고객 요청 차량 가격: {price}만원</>,
	},
	PRICE_ADJUSTMENT_REQUEST: {
		title: '가격 조정 중이에요',
		subTitle: '잠시만 기다려주세요',
	},
	PRICE_ADJUSTMENT_COMPLETE: {
		title: (
			<>
				최종 차량가격
				<br />
				<span style={{ color: '#FF2626', fontWeight: 'bold', fontSize: '22px' }}>{price}만원</span>으로 조정되었습니다
			</>
		),
		subTitle: '최종 차량 가격을 확인하고 구매하세요',
	},
});
export const REFUND_TIT = {
	COMPLETE_PAYMENT: {
		title: '환불요청',
		subTitle: '담당자가 확인 후 연락드리겠습니다.',
	},
	REQUEST_REFUND: {
		title: '환불 요청을 확인중입니다.',
		subTitle: '담당자가 확인 후 연락드리겠습니다.',
		miniTitle: '환불요청',
	},
	CONFIRM_REFUND: {
		title: '환불되었어요.',
		subTitle: '',
		miniTitle: '환불완료',
	},
	COMPLETE_BALANCE: {
		title: '환불요청',
		subTitle: '담당자가 확인 후 연락드리겠습니다.',
	},
	COMPLETE_DOWN_PAYMENT: {
		title: '환불요청',
		subTitle: '담당자가 확인 후 연락드리겠습니다.',
	},
};

export const PROGRESS_STATUS = {
	RESERVATION_REQUEST: {
		// 예약 신청
		titTop: '방문 가능 여부 확인 중',
		subTop: '방문 희망일 전날 확정 여부를 안내해드려요',
		titBottom: '방문 예약 확정',
		subBottom: '예약 확정 후 믿고 센터 방문이 가능해요',
	},
	RESERVATION_CONFIRMED: {
		// 예약 확정
		titTop: '방문예약 확정',
		subTop: '방문시간을 꼭 지켜주세요',
		titBottom: '방문예정',
		subBottom: '믿고 수원센터로 방문해주세요',
	},
	PURCHASE_CONSULTATION: {
		// 계약중 입금전
		titTop: '결제 진행중',
		subTop: '차량 대금 결제, 보험 가입 여부 확인 중',
		titBottom: '전자계약서 작성',
		subBottom: '계약서 작성 후 차량 출고 예정',
	},
	PURCHASE_CONSULTATION_BEFORE_CONTRACT: {
		// 계약중 입금 후 전자계약서 작성전
		titTop: '전자계약서 작성중',
		subTop: '전자계약서 작성후 차량 출고 예정',
		titBottom: '차량 출고',
		subBottom: '7일간 타보고 차량 구매확정',
	},
	COMPLETE_PAYMENT: {
		// 결제완료
		titTop: '구매완료',
		subTop: '타면서 구매확정 여부를 결정해주세요',
		titBottom: '구매확정',
		subBottom: '7일 후 자동으로 구매 확정됩니다.',
	},
	COMPLETE_DOWN_PAYMENT: {
		// 엔카페이
		titTop: '구매완료',
		subTop: '타면서 구매확정 여부를 결정해주세요',
		titBottom: '구매확정',
		subBottom: '7일 후 자동으로 구매 확정됩니다.',
	},
	UNPAID_BALANCE: {
		// 잔금 미입금
		titTop: '구매완료',
		subTop: '타면서 구매확정 여부를 결정해주세요',
		titBottom: '구매확정',
		subBottom: '엔카페이 잔금 결제 후 차량 구매확정',
	},
	CONFIRM_INCOMPLETE: {
		// 미종결처리
		titTop: '구매완료',
		subTop: '타면서 구매확정 여부를 결정해주세요',
		titBottom: '구매확정',
		subBottom: '엔카페이 잔금 결제 후 차량 구매확정',
	},
	COMPLETE_BALANCE: {
		// 엔카페이 잔금 입금 완료
		titTop: '구매완료',
		subTop: '타면서 구매확정 여부를 결정해주세요',
		titBottom: '구매확정',
		subBottom: '7일 후 자동으로 구매 확정됩니다.',
	},
};

export const PROGRESS_STATUS_SELLER = {
	// 판매자
	RESERVATION_REQUEST: {
		titTop: '차량 입고 대기중',
		subTop: 'time까지 입고 필요',
		titBottom: '고객 방문 예정',
		subBottom: 'time',
	},
	RESERVATION_CONFIRMED_NULL: {
		// 판매자 예약신청
		titTop: '차량 입고 대기중',
		subTop: 'time까지 입고 필요',
		titBottom: '고객 방문 예정',
		subBottom: 'time',
	},
	RESERVATION_CONFIRMED_RECEIVING_VEHICLE: {
		// 판매자 입고확인
		titTop: '믿고 센터 입고 확인',
		subTop: 'time 입고 완료',
		titBottom: '고객 방문 예정',
		subBottom: 'time',
	},
	RESERVATION_CONFIRMED_RECEIVING_VEHICLE_DEALER_CONFIRM: {
		// 판매자 입고완료
		titTop: '믿고 센터 입고 완료',
		subTop: 'time 입고 완료',
		titBottom: '고객 방문 예정',
		subBottom: 'time',
	},
	VISIT_COMPLETE: {
		// 판매자 방문완료
		titTop: '믿고 센터 입고 완료',
		subTop: 'time 입고 완료',
		titBottom: '고객 방문 완료',
		subBottom: 'time',
	},
	PURCHASE_CONSULTATION: {
		// 판매자 계약중
		titTop: '고객 방문완료',
		subTop: 'time',
		titBottom: '차량 계약중',
		subBottom: '고객이 차량을 계약중입니다.',
	},
	COMPLETE_DOWN_PAYMENT: {
		// 판매자 계약중
		titTop: '고객 방문완료',
		subTop: 'time',
		titBottom: '차량 계약중',
		subBottom: '고객이 차량을 계약중입니다.',
	},
	COMPLETE_PAYMENT: {
		// 판매자 판매완료
		titTop: '고객 방문 완료',
		subTop: 'time',
		titBottom: '차량판매, 출고 완료',
		subBottom: 'time',
	},
	COMPLETE_BALANCE: {
		// 판매자 엔카페이 잔금입금완료
		titTop: '고객 방문 완료',
		subTop: 'time',
		titBottom: '차량판매, 출고 완료',
		subBottom: 'time',
	},
	CONFIRM_PURCHASE: {
		// 판매자 구매확정
		titTop: '차량판매, 출고 완료',
		subTop: 'time',
		titBottom: '고객 차량구매 확정',
		subBottom: 'time',
	},
	RESERVATION_CANCEL_RECEIVING_VEHICLE: {
		// 입고 후 예약취소, 수거 전
		titTop: '차량 입고 일시',
		subTop: 'time',
		titBottom: '입고 차량 수거 필요',
		subBottom: '수거마감: time',
	},
	RECEIVING_VEHICLE_GIVE_VEHICLE_BACK: {
		// 입고 후 예약취소, 수거 후
		titTop: '방문예약 취소',
		subTop: 'time',
		titBottom: '입고 차량 수거 완료',
		subBottom: '수거완료: time',
	},
	CANCEL_PURCHASE_RECEIVING_VEHICLE: {
		// 구매취소, 수거전
		titTop: '차량 입고 일시',
		subTop: 'time',
		titBottom: '입고 차량 수거 필요',
		subBottom: '수거마감: time',
	},
	CANCEL_PURCHASE_GIVE_VEHICLE_BACK: {
		// 구매취소, 수거후
		titTop: '차량구매 취소',
		subTop: 'time',
		titBottom: '입고 차량 수거 완료',
		subBottom: '수거완료: time',
	},
	PRICE_ADJUSTMENT_OFFER: {
		titTop: '믿고 센터 입고 확인',
		subTop: 'time 입고 완료',
		titBottom: '고객 방문완료, 가격 할인 요청',
		subBottom: 'time',
	},
	PRICE_ADJUSTMENT_COUNTER_OFFER: {
		titTop: '고객 방문완료, 가격 할인 요청',
		subTop: 'time',
		titBottom: '할인된 가격 정보 전달',
		subBottom: 'time',
	},
	PRICE_ADJUSTMENT_APPROVE: {
		titTop: '고객 방문완료, 가격 할인 요청',
		subTop: 'time',
		titBottom: '할인된 가격 정보 전달',
		subBottom: 'time',
	},
};

export const BTN_NAME = {
	RESERVATION_REQUEST: '믿고 차량 더 보러가기',
	RESERVATION_CANCEL: '믿고 차량 더 보러가기',
	RESERVATION_CONFIRMED: '믿고 차량 더 보러가기',
	CANCEL_PURCHASE: '믿고 차량 더 보러가기',
	VISIT_COMPLETE: '다음',
	PURCHASE_CONSULTATION: '전자계약서 작성',
	PURCHASE_CONSULTATION_BEFORE_CONTRACT: '전자계약서 작성',
	COMPLETE_DOWN_PAYMENT: '구매확정',
	COMPLETE_PAYMENT: '구매확정',
	COMPLETE_BALANCE: '구매확정',
	CONFIRM_REFUND: '다른 믿고 차량 보러가기',
	CONFIRM_INCOMPLETE: '구매확정',
	UNPAID_BALANCE: '구매확정',
};

export const PURCHASE_CANCEL_REASON_LIST = [
	{ idx: 0, title: '단순변심', value: 'CANCEL_CHANGED_MIND' },
	{ idx: 1, title: '다른차량구매', value: 'CANCEL_BUY_ANOTHER_VEHICLE' },
	{ idx: 2, title: '타 사 이용', value: 'CANCEL_USING_ANOTHER_COMPANY' },
	{ idx: 3, title: '결제관련', value: 'CANCEL_PAYMENT_RELATED' },
	{ idx: 4, title: '차량관련', value: 'CANCEL_VEHICLE_RELATED' },
	{ idx: 5, title: '기타', value: 'CANCEL_ETC' },
];

export const LIST_TAB_STATUS = [
	{
		title: '예약/구매 내역',
		id: 'NON_CANCEL_STATUS',
	},
	{
		title: '취소/환불 내역',
		id: 'CANCEL_STATUS',
	},
];

export const LIST_TAB_STATUS_TITLE = [
	{
		title: '전체',
		id: '',
	},
	{
		title: '예약신청',
		id: 'RESERVATION_REQUEST',
	},
	{
		title: '예약확정',
		id: 'RESERVATION_CONFIRMED',
	},
	{
		title: '방문완료',
		id: 'VISIT_COMPLETE',
	},
	{
		title: '계약중',
		id: 'PURCHASE_CONSULTATION',
	},
	{
		title: '구매완료',
		id: 'COMPLETE_PURCHASE',
	},
	{
		title: '구매확정',
		id: 'CONFIRM_PURCHASE',
	},
	{
		title: '취소',
		id: 'CANCEL',
	},
	{
		title: '환불',
		id: 'REFUND',
	},
];
export const ENLOG_RESERVATION_STATUS = {
	RESERVATION_REQUEST: '예약신청접수',
	RESERVATION_CANCEL: '예약취소',
	RESERVATION_CONFIRMED: '예약확정',
	VISIT_CANCEL: '방문취소',
	VISIT_COMPLETE: '방문완료',
	PURCHASE_CONSULTATION: '계약중',
	COMPLETE_DOWN_PAYMENT: '구매완료',
	COMPLETE_PAYMENT: '구매완료',
	CONFIRM_PURCHASE: '구매확정',
	CANCEL_PURCHASE: '구매취소',
	COMPLETE_BALANCE: '잔금입금완료',
	// 가격조정 추후개발 예정
	// PRICE_ADJUSTMENT_REQUEST: '가격조정중',
	// PRICE_ADJUSTMENT_COMPLETE: '가격조율완료',
	RECEIVING_VEHICLE: '입고확인',
	RECEIVING_VEHICLE_DEALER_CONFIRM: '입고완료',
	RESERVATION_CANCEL_NULL: '예약취소',
	RESERVATION_CANCEL_RECEIVING_VEHICLE: '입고 후 예약 취소, 수거 전',
	RECEIVING_VEHICLE_GIVE_VEHICLE_BACK: '입고 후 예약취소, 수거완료',
	CANCEL_PURCHASE_RECEIVING_VEHICLE: '구매취소, 수거전',
	CANCEL_PURCHASE_GIVE_VEHICLE_BACK: '구매취소, 수거완료',
};

export const ENLOG_RESERVATION_STATUS_REFUND = {
	COMPLETE_PAYMENT: '환불사유입력',
	REQUEST_REFUND: '환불요청',
	CONFIRM_REFUND: '환불완료',
	PURCHASE_CONSULTATION: '환불완료',
};

export const USAGE = [
	{
		num: '01',
		title: '방문 예약 신청',
		content: (
			<>
				차량을 확인하고 싶은 날짜와 시간에
				<br />
				방문예약을 신청하세요.
			</>
		),
	},
	{
		num: '02',
		title: '믿고 방문 예약 신청',
		content: (
			<>
				예약이 확정되면 신청한 일시에
				<br />
				맞춰 방문해 주세요.<span>15분 이상 늦으시면 차량 확인이 어려울 수 있습니다.</span>
			</>
		),
	},
	{
		num: '03',
		title: '차량 확인',
		content: (
			<>
				예약이 확정되면, 신청한 날짜와 시간
				<br />에 맞춰 방문해 차량을 확인하세요.<span>엔카 믿고 거래존에서 확인할 수 있어요.</span>
			</>
		),
	},
	{
		num: '04',
		title: '결제',
		content: (
			<>
				결제, 대출 과정의 복잡한 절차를
				<br />
				함께 도와드려요.
			</>
		),
	},
	{
		num: '05',
		title: '전자계약서 작성 후 출고',
		content: (
			<>
				결제 후 전자계약서를
				<br />
				작성하면 차량이 출고돼요.<span>원활한 계약을 위해 명의자 신분증을 꼭 챙겨주세요.</span>
			</>
		),
	},
	{
		num: '06',
		title: '7일간 타보며 구매확정',
		content: (
			<>
				차량 출고 후 7일 동안 타보며
				<br />
				최종 구매확정 여부를 결정하세요.<span>구매확정되면 명의이전 절차가 진행됩니다.</span>
			</>
		),
	},
];

export const FAQ = [
	{
		title: '"엔카믿고 방문"은 어떤 서비스인가요?',
		text: <>엔카에서 점검한 차량을 엔카 믿고 거래존에 방문하여 확인하고 7일간 타보면서 구매를 결정할 수 있는 서비스입니다.</>,
	},
	{
		title: '방문예약은 어떻게 하나요?',
		text: (
			<>
				엔카 믿고 거래존에 원하는 날짜와 시간에 방문예약을 신청하실 수 있습니다. 방문 가능 여부를 확인하고 예약을 확정하면 방문예약한 날짜와
				시간에 센터로 방문해주시면 됩니다.
			</>
		),
	},
	{
		title: '엔카믿고 방문 차량은 어떤 점이 다른가요?',
		text: (
			<>
				엔카믿고 방문 차량은 엔카 직영 성능장에서 자동차 주요 장치 69개 항목에 대해 성능점검을 마쳐 보다 안심하고 구매하실 수 있는 차량입니다.
			</>
		),
	},
	{
		title: '차량설명은 어떤 방식으로 이루어지나요?',
		text: (
			<>
				엔카 믿고 거래존에 준비된 체크리스트를 통해 직접 확인하거나 판매자(딜러)를 만나 차량을 확인하고 상담할 수 있습니다. 엔카는 편안하고
				안전하게 상담받으실 수 있도록 도와드립니다.
			</>
		),
	},
	{
		title: '어떤 결제수단을 선택할 수 있나요?',
		text: (
			<>
				a. 현금결제
				<br />
				&#8544;.가상계좌 생성 후 구매비용 전액을 무통장 입금
				<br />
				b. 현금 + 할부
				<br />
				&#8544;.금융상담사 통해 대출 한도와 금리 조회
				<br />
				&#8545;.대출 실행
				<br />
				&#8546;.가상계좌 생성 후 구매비용 전액을 무통장 입금
				<br />
				c. 엔카페이
				<br />
				&#8544;.금융상담사 통해 엔카페이 체결
				<br />
				&#8545;.가상계좌 생성 후 일부 구매비용을 무통장 입금
				<br />
				&#8546;.차량 픽업 후 최종구매 시 잔금 입금 (현금 또는 대출 선택 가능)
				<br />
				&nbsp;&nbsp;&nbsp;&nbsp;(일부 차량에 대해서는 엔카페이 적용이 불가할 수 있습니다.)
			</>
		),
	},
	{
		title: '차량가격 외에 추가 비용이 발생하나요?',
		text: (
			<>
				중고차를 구매하기 위해서는 이전비, 관리비(매도비), 믿고서비스 이용료, 자동차성능 상태점검 보험료가 발생합니다.
				<br />
				이전비는 취등록세, 법정수수료, 인지세, 증지대, 대행료 등의 항목이 포함되며, 관련 규정에 근거하여 이전 절차 진행 후 남는 잔액은
				구매진행 시 입력한 환불계좌로 환급해드립니다.
				<br />
				다만, 반대로 이전 중 일부 금액이 부족한 경우에는 추가비용이 발생할 수 있습니다.
			</>
		),
	},
	{
		title: '차량 출고 후 구매확정 전까지 자동차 보험 가입이 필요한가요?',
		text: (
			<>
				구매확정 전까지의 기간에 대해 직접 ‘자동차 의무보험’에 가입하셔야 합니다.
				<br />
				보험가입 확인 후 전자계약서 작성 및 차량 출고가 가능합니다.
				<br />
				단기보험 가입 시 최종구매확정 이후에 명의 이전이 제한됩니다.
				<br />
				최종구매확정 이후에는 1년 의무보험으로 필수 가입을 요청드립니다.
			</>
		),
	},
	{
		title: '현금영수증 발행이 가능한가요?',
		text: (
			<>
				네, 중고차도 소득공제가 가능합니다.
				<br />
				세금을 제외한 차량금액, 서비스 비용 등 의무 발행을 도와드리고 있습니다.
				<br />
				단, 조세특례제한법에 따라 차량 명의자 앞으로 발행되며, 명의자 외 가족 및 타인으로는 발행이 불가합니다.
			</>
		),
	},

	{
		title: '계약은 어떤 절차로 이루어지나요?',
		text: (
			<>
				차량을 확인하고 구매를 결정하면, 엔카 전자계약 시스템을 통해 모든 계약 절차가 진행됩니다. 결제, 대출, 전자계약서 작성 등의 과정이
				진행됩니다.
				<br />
				(엔카 전자계약을 통한 거래 시, 7일간 타보고 결정할 수 있는 혜택을 누릴 수 있지만, 판매자(딜러)를 통한 거래 시에는 해당 혜택이 적용되지
				않습니다.)
			</>
		),
	},
	{
		title: '계약 시 필요한 서류는 무엇인가요?',
		text: (
			<>
				원활한 계약 진행을 위해서 신분증 사본 및 인적사항이 필요합니다.
				<br />
				기타 혜택 기준(국가유공자, 장애인, 다자녀 등)에 따라 추가 증빙서류가 필요할 수 있습니다.
				<br />※ 법인고객의 경우 법인인감증명서, 법인등기부등본 필요
			</>
		),
	},
	{
		title: '차량 명의는 언제 이전되나요?',
		text: (
			<>
				최종적으로 차량을 구매확정하는 시점부터 명의이전 절차가 진행됩니다. (영업일 기준 2~3일 소요)
				<br />
				이전된 등록증은 구매진행 시 입력한 우편등기 주소로 등기우편 발송됩니다. (차량 출고 후 15일 정도 소요)
			</>
		),
	},

	{
		title: '구매확정은 언제까지 하면 되나요?',
		text: (
			<>
				전자계약서 작성 완료 후 차량이 출고되면 7일 동안 최종 구매확정 여부를 결정할 수 있습니다.
				<br />
				환불 마감일인 7일이 지나면 자동으로 구매확정이 이루어지며, 구매확정 완료 후 명의이전 절차가 진행됩니다.
				<br />※ 전자계약서 서명 필수
				<br />※ 엔카페이로 결제한 경우 최종결제수단 선택 및 잔금 입금 필수
			</>
		),
	},

	{
		title: '환불 시 별도 비용이 있나요?',
		text: (
			<>
				3일 이내(차량 출고일 포함)에 환불요청할 경우 재상품화 비용(단순변심일 경우)을 제외한 별도의 비용은 발생되지 않으며, 4일 이후부터는
				중고차 시장에서 통용되는 차량 이용료가 발생됩니다.
				<br />
				(단, 차량가격이 5천만원 이상인 차량은 2일 차부터 비용이 발생됩니다.{' '}
				<Link
					to="/home-service/refund"
					style={{ textDecoration: 'underline' }}
				>
					환불약관 보기
				</Link>
				)
			</>
		),
	},
	{
		title: '환불이 불가능할 수도 있나요?',
		text: (
			<>
				차량 출고 후 차량의 사고, 고의적인 파손, 범죄에 이용되는 경우는 환불 대상에서 제외됩니다.
				<br />
				또한, 임의의 추가 장착품 및 차량에 투입된 비용도 환불 대상에서 제외됩니다.
				<br />
				(블랙박스 장착비용, 썬팅비용, 타이어 교체 비용, 각종 오일 교체 비용, 광택 및 세차비용, 주유비, 통행료 등)
				<br />
				다만, 장착품 중 탈거가 가능한 경우 차량이 훼손되지 않는 범위에서 탈거 후 반환은 가능합니다.
			</>
		),
	},
];

export const NOTICE = [
	{ text: <>믿고 서비스는 방문예약 신청 후, 예약 확정이 되어야 센터 방문이 가능합니다.</> },
	{ text: <>예약 확정 여부는 방문 희망일 전날 안내 채팅 또는 카카오 알림톡으로 알려드립니다.</> },
	{ text: <>먼저 예약 방문한 고객이 구매를 결정한 경우 예약이 취소될 수 있습니다.</> },
	{
		text: <>믿고 환불약관에 따라 서비스 이용료가 발생할 수 있습니다.</>,
	},
	{ text: <>환불 마감일(7일)이 지나면 자동으로 구매확정이 이루어지며, 구매확정 완료 후 이전처리가 진행됩니다.</> },
];

export const MEETGO_RESERVATION_CODE = {
	ALREADY_CONTRACTED_VEHICLE: 'ALREADY_CONTRACTED_VEHICLE', // 이미 계약된 차량 입니다.
	ALREADY_CHECKUP_PROGRESS_VEHICLE: 'ALREADY_CHECKUP_PROGRESS_VEHICLE', // 이미 전문가 출장(출장검수) 진행중인 차량
	ALREADY_CUSTOMER_RESERVATION_VEHICLE: 'ALREADY_CUSTOMER_RESERVATION_VEHICLE', // 이미 방문신청을 완료한 차량입니다.신청내역을 확인해주세요
	UNAVAILABLE_RESERVATION_DATE: 'UNAVAILABLE_RESERVATION_DATE', // 해당 날짜에는 신청이 불가합니다.
	UNAVAILABLE_RESERVATION_TIME: 'UNAVAILABLE_RESERVATION_TIME', // 해당 시간에는 신청이 불가합니다.
	EXCEED_VIDEO_RESERVATION: 'EXCEED_VIDEO_RESERVATION', // 화상상담은 최대 10건 까지만 가능합니다.
	BEFORE_MINIMUM_AVAILABLE_RESERVATION_TIME: 'BEFORE_MINIMUM_AVAILABLE_RESERVATION_TIME', // 해당 시간에는 신청이 불가합니다.
};

export const MEETGO_RESERVATION_WALK_IN_MESSAGE = {
	ALREADY_CONTRACTED_VEHICLE: '이미 계약된 차량입니다.',
	ALREADY_CUSTOMER_RESERVATION_VEHICLE: '동일한 차량으로 방문상담 신청이 불가합니다',
	UNAVAILABLE_RESERVATION_DATE: '선택한 날짜에는 방문신청이 불가합니다.\n다른 시간을 선택해주세요.',
	UNAVAILABLE_RESERVATION_TIME: '선택한 시간에는 방문신청이 불가합니다.\n다른 시간을 선택해주세요.',
	BEFORE_MINIMUM_AVAILABLE_RESERVATION_TIME: '선택한 시간에는 방문신청이 불가합니다.\n다른 시간을 선택해주세요.',
};
export const MEETGO_RESERVATION_VIDEO_MESSAGE = {
	ALREADY_CONTRACTED_VEHICLE: '이미 계약된 차량입니다.',
	ALREADY_CUSTOMER_RESERVATION_VEHICLE: '동일한 차량으로 화상상담 신청이 불가합니다',
	EXCEED_VIDEO_RESERVATION: '화상상담은\n최대 10건 까지만 가능합니다.',
	UNAVAILABLE_RESERVATION_DATE: '해당 날짜에는 신청이 불가합니다.',
	UNAVAILABLE_RESERVATION_TIME: '해당 시간에는 신청이 불가합니다.',
	BEFORE_MINIMUM_AVAILABLE_RESERVATION_TIME: '해당 시간에는 신청이 불가합니다.',
};

export const MEETGO_CONTRACT_IMPOSSIBLE_MESSAGE = '차량이 계약 상태이기 때문에 신청이 불가합니다.';

export const MEETGO_TYPE_LABEL = {
	VIDEO_CALL: '화상상담',
	WALK_IN: '방문예약',
};

export const MEETGO_RESERVATION_TYPE = {
	VIDEO_CALL: 'VIDEO_CALL',
	WALK_IN: 'WALK_IN',
};

export const VIDEO_NO_SELECT_MESSAGE = '상담일정 선택이 필요합니다.';

export const WALKIN_PRIVACY_TERM_MAKER = () => [
	{
		name: 'privacy',
		label: '개인정보 수집/이용 동의(필수)',
		link: '/meetgo/policy/reservation',
		isRequired: true,
		target: '_blank',
	},
];

export const MEETGO_PAGE_ROUTE = {
	WALKIN_INTRO: '/meetgo/walk-in/intro',
	WALKIN_BRIDGE: '/meetgo/walk-in/bridge',
	WALKIN_RESERVATION: '/meetgo/reservation/date',
	WALKIN_APPLY_END: '/meetgo/walk-in/apply/end',

	POLICY_TERM: '/home-service/terms',
	PRIVACY_TERM: '/meetgo/policy/reservation?type=walk_in',
	VIDEO_INTRO: '/meetgo/video-call/intro',
};

export const MEETGO_INFLOW_TYPE = {
	카카오: 'kakao',
};

export const replaceReservationId = (url, Id) => {
	if (typeof url === 'string') {
		return url.replace(':reservationId', Id);
	}
	return null;
};

export const WALKIN_PROGRESS_STATUS = {
	APPLY: 'APPLY',
	CONFIRM: 'CONFIRM',
	VISIT_END: 'VISIT_END',
};

export const WALK_IN_RESERVATION_DETAIL_PAGE_LAYER_TYPE = {
	MORE_RECOMMEND: 'MORE_RECOMMEND',
	MORE_RESERVATION: 'MORE_RESERVATION',
	RESERVATION_CANCEL: 'RESERVATION_CANCEL',
	RESERVATION_CHANGE: 'RESERVATION_CHANGE',
	MORE_RESERVATION_NOT_POSSIBLE: 'MORE_RESERVATION_NOT_POSSIBLE',
	MORE_RESERVATION_INFO: 'MORE_RESERVATION_INFO',
	MORE_RESERVATION_END: 'MORE_RESERVATION_END',
};

export const SAFETY_ZONE_IMG = { code: 'safetyZoneCode', path: '/assets/images/meetgo/cars_safety_zone.jpg' };

export const WALKIN_RESERVATION_TYPE = {
	DEFAULT: 'DEFAULT',
	SAFETY_ZONE_EXPERT: 'SAFETY_ZONE_EXPERT',
};

// 전문가 동행 서비스 가격 (국산/수입 차종별 상이)
export const MEETGO_EXPERT_PRICE = {
	DOMESTIC: 69000,
	IMPORTED: 99000,
};
export const WALKIN_RESERVATION_TYPE_LABEL = {
	[WALKIN_RESERVATION_TYPE.DEFAULT]: '믿고방문',
	[WALKIN_RESERVATION_TYPE.SAFETY_ZONE_EXPERT]: '믿고방문_전문가동행신청완료',
};
